import { render, staticRenderFns } from "./abilityTeam.vue?vue&type=template&id=8c776534&scoped=true"
import script from "./abilityTeam.vue?vue&type=script&lang=js"
export * from "./abilityTeam.vue?vue&type=script&lang=js"
import style0 from "./abilityTeam.vue?vue&type=style&index=0&id=8c776534&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c776534",
  null
  
)

export default component.exports